"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wsClient = 'ws.manager';
exports.wsVs = 'ws.vs';
exports.userChannel = '@user-inbox';
//# sourceMappingURL=constants.js.map